import { FC } from 'react';
import {
	ROUTE_SPORTSBOOK,
	ROUTE_SPORTSBOOK_BROWSE,
	ROUTE_SPORTSBOOK_EVENTS,
	ROUTE_SPORTSBOOK_LEAGUES,
	ROUTE_SPORTSBOOK_LIVE_PAGE,
	ROUTE_SPORTSBOOK_MY_BETS_OPEN,
	ROUTE_SPORTSBOOK_MY_BETS_SETTLED,
	ROUTE_SPORTSBOOK_SPORTS_PAGE
} from '../../../router/constants';
import SportsbookSeoLobbyHeader from './sportsbook-seo-lobby-header';
import { Route } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import { getRelativePaths } from '../../../../utils/pathname';

const MY_SETTLED_BETS_PAGE_SITE_TITLE = 'SPORTSBOOK_MY_SETTLED_BETS_PAGE_SITE_TITLE';
const MY_SETTLED_BETS_PAGE_META_DESCRIPTION = 'SPORTSBOOK_MY_SETTLED_BETS_PAGE_META_DESCRIPTION';

const BROWSE_PAGE_SITE_TITLE = 'SPORTSBOOK_BROWSE_PAGE_SITE_TITLE';
const BROWSE_PAGE_META_DESCRIPTION = 'SPORTSBOOK_BROWSE_PAGE_META_DESCRIPTION';

const LIVE_START_PAGE_SITE_TITLE = 'SPORTSBOOK_LIVE_PAGE_SITE_TITLE';
const LIVE_START_PAGE_META_DESCRIPTION = 'SPORTSBOOK_LIVE_PAGE_META_DESCRIPTION';

const EVENT_PAGE_SITE_TITLE = 'SPORTSBOOK_EVENT_PAGE_SITE_TITLE';
const EVENT_PAGE_META_DESCRIPTION = 'SPORTSBOOK_EVENT_PAGE_META_DESCRIPTION';

const LEAGUE_PAGE_SITE_TITLE = 'SPORTSBOOK_LEAGUE_PAGE_SITE_TITLE';
const LEAGUE_PAGE_META_DESCRIPTION = 'SPORTSBOOK_LEAGUE_PAGE_META_DESCRIPTION';

const SPORT_PAGE_SITE_TITLE = 'SPORTSBOOK_SPORT_PAGE_SITE_TITLE';
const SPORT_PAGE_META_DESCRIPTION = 'SPORTSBOOK_SPORT_PAGE_META_DESCRIPTION';

const MY_OPEN_BETS_PAGE_SITE_TITLE = 'SPORTSBOOK_MY_OPEN_BETS_PAGE_SITE_TITLE';
const MY_OPEN_BETS_PAGE_META_DESCRIPTION = 'SPORTSBOOK_MY_OPEN_BETS_PAGE_META_DESCRIPTION';

const EXPLORE_PAGE_SITE_TITLE = 'SPORTSBOOK_EXPLORE_PAGE_SITE_TITLE';
const EXPLORE_PAGE_META_DESCRIPTION = 'SPORTSBOOK_EXPLORE_PAGE_META_DESCRIPTION';

const DEFAULT_SITE_TITLE = 'SPORTSBOOK_SITE_TITLE';
const DEFAULT_META_DESCRIPTION = 'SPORTSBOOK_META_DESCRIPTION';

/**
 * Sets general page title and description for sportsbook routes that have
 * static titles and descriptions.
 *
 * Also works as a fallback in case new routes are added and we forget to add specific
 * helmet data. For instance if we add a new route /sportsbook/live/hot then the /live
 * title and description will be used as a fallback.
 *
 * Pages that need more specific or dynamic title and description may override whatever
 * is set here using the default override behaviour provided by react-helmet.
 */
const SportsbookSeoLobbyHeaderContainer: FC = () => (
	<TracedRoutes>
		{/* Explore Page */}
		<Route
			index
			element={
				<SportsbookSeoLobbyHeader
					titleTextKey={EXPLORE_PAGE_SITE_TITLE}
					descriptionTextKey={EXPLORE_PAGE_META_DESCRIPTION}
				/>
			}
		/>
		{/* My bets */}

		<Route
			path={`${getRelativePaths(ROUTE_SPORTSBOOK_MY_BETS_SETTLED, ROUTE_SPORTSBOOK)}/*`}
			element={
				<SportsbookSeoLobbyHeader
					titleTextKey={MY_SETTLED_BETS_PAGE_SITE_TITLE}
					descriptionTextKey={MY_SETTLED_BETS_PAGE_META_DESCRIPTION}
				/>
			}
		/>
		<Route
			path={`${getRelativePaths(ROUTE_SPORTSBOOK_MY_BETS_OPEN, ROUTE_SPORTSBOOK)}/*`}
			element={
				<SportsbookSeoLobbyHeader
					titleTextKey={MY_OPEN_BETS_PAGE_SITE_TITLE}
					descriptionTextKey={MY_OPEN_BETS_PAGE_META_DESCRIPTION}
				/>
			}
		/>

		{/* Browse */}

		<Route
			path={`${getRelativePaths(ROUTE_SPORTSBOOK_BROWSE, ROUTE_SPORTSBOOK)}/*`}
			element={
				<SportsbookSeoLobbyHeader
					titleTextKey={BROWSE_PAGE_SITE_TITLE}
					descriptionTextKey={BROWSE_PAGE_META_DESCRIPTION}
				/>
			}
		/>

		{/* Live Page */}

		<Route
			path={`${getRelativePaths(ROUTE_SPORTSBOOK_LIVE_PAGE, ROUTE_SPORTSBOOK)}/*`}
			element={
				<SportsbookSeoLobbyHeader
					titleTextKey={LIVE_START_PAGE_SITE_TITLE}
					descriptionTextKey={LIVE_START_PAGE_META_DESCRIPTION}
				/>
			}
		/>

		{/* Event Page */}

		<Route
			path={`${getRelativePaths(ROUTE_SPORTSBOOK_EVENTS, ROUTE_SPORTSBOOK)}/*`}
			element={
				<SportsbookSeoLobbyHeader
					titleTextKey={EVENT_PAGE_SITE_TITLE}
					descriptionTextKey={EVENT_PAGE_META_DESCRIPTION}
				/>
			}
		/>

		{/* Leage Page */}

		<Route
			path={`${getRelativePaths(ROUTE_SPORTSBOOK_LEAGUES, ROUTE_SPORTSBOOK)}/*`}
			element={
				<SportsbookSeoLobbyHeader
					titleTextKey={LEAGUE_PAGE_SITE_TITLE}
					descriptionTextKey={LEAGUE_PAGE_META_DESCRIPTION}
				/>
			}
		/>

		{/* Sports Page */}

		<Route
			path={`${getRelativePaths(ROUTE_SPORTSBOOK_SPORTS_PAGE, ROUTE_SPORTSBOOK)}/*`}
			element={
				<SportsbookSeoLobbyHeader
					titleTextKey={SPORT_PAGE_SITE_TITLE}
					descriptionTextKey={SPORT_PAGE_META_DESCRIPTION}
				/>
			}
		/>

		{/* Fallback */}

		<Route
			element={
				<SportsbookSeoLobbyHeader
					titleTextKey={DEFAULT_SITE_TITLE}
					descriptionTextKey={DEFAULT_META_DESCRIPTION}
				/>
			}
		/>
	</TracedRoutes>
);

export default SportsbookSeoLobbyHeaderContainer;
